import * as ApprovalStatus from "@/constants/approval-status";
import * as CustomChargeTypes from "@/constants/custom-charge-types";
import * as OrderStatuses from "../constants/order-statuses";

const OrderUtils = {
    /**
     * @param {Object} order
     * @returns {boolean}
     */
    /* It's checking if the order is closed. */
    isClosed(order) {
        if (order.is_closed) {
            return true;
        }
        if (!order.statuses) {
            return false;
        }
        let statuses = [];
        if (order.has_flat_shipment) {
            statuses.push(OrderStatuses.FLATS_SHIPPED);
        }
        if (order.has_poster_shipment) {
            statuses.push(OrderStatuses.WALL_POSTERS_SHIPPED);
        }
        return (
            order.statuses.data.filter(
                (i) => i.checked && statuses.includes(i.status)
            ).length === statuses.length
        );
    },
    /**
     * @param {Object} order
     * @returns {boolean}
     */
    isDue(order) {
        let created_at = moment.utc(order.last_status_update).local();
        return moment().diff(created_at, "days") >= 2;
    },
    /**
     * @param {Object} order
     * @returns {boolean}
     */
    isApproved(order) {
        return order.approval_status === ApprovalStatus.APPROVED;
    },
    /* It's calculating the totals for the order. */
    getTotals(order, summary) {
        let totals = [];
        let discount = 0;
        let rush_processing_fee = 0;
        let printed_items_amount = 0;
        let tax = 0;
        let shipping_charge = _.get(summary, "shipping_rate.charge", 0);
        let newsletter_amount = 0;

        let subtotal = _.sumBy(summary.orders, (item) => {
            if (item.calendar) {
                let calendar_amount = _.sumBy(item.sizes, "amount");
                printed_items_amount += calendar_amount;
                let digital_files_amount = _.sumBy(
                    item.digital_files,
                    (file) => {
                        return file.price;
                    }
                );
                return calendar_amount + digital_files_amount;
            } else {
                printed_items_amount += item.amount;
                newsletter_amount += item.amount;
                return item.amount;
            }
        });
        if (this.subscription_charge.subscription_interval) {
            totals.push({
                label:
                    (this.subscription_charge.subscription_interval === 1
                        ? "Monthly"
                        : "Yearly") + " Subscription",
                amount: this.subscription_charge.subscription_amount
            });
            subtotal += this.subscription_charge.subscription_amount;
        }
        totals.push({
            label: "Subtotal",
            amount: subtotal
        });
        if (!order.tax_exempt) {
            totals.push({
                label: "Sales Tax",
                amount: (tax = subtotal * 0.1)
            });
        }
        totals.push({
            label: "Shipping",
            loading: this.loadingShipping,
            amount: shipping_charge
        });
        if (this.orderForm.rush_processing) {
            totals.push({
                label: "Rush Processing Fee",
                amount: this.rushProcessingFee
            });
            rush_processing_fee = this.rushProcessingFee;
        }
        let custom_charge_total = 0;
        this.$store.state.current_community.custom_charges.data.forEach(
            (charge) => {
                let orig_amount =
                    charge.type === CustomChargeTypes.AMOUNT
                        ? charge.value
                        : printed_items_amount * charge.value;
                custom_charge_total +=
                    (charge.type === CustomChargeTypes.PERCENTAGE ? -1 : 1) *
                    orig_amount;
                let amount = Math.abs(orig_amount);
                totals.push({
                    label: charge.name,
                    amount,
                    subtract:
                        charge.value < 0 ||
                        charge.type === CustomChargeTypes.PERCENTAGE
                });
            }
        );
        if (this.discountRate > 0) {
            totals.push({
                label: `Discount (${this.discountRate * 100}%)`,
                amount: (discount = printed_items_amount * this.discountRate),
                subtract: true
            });
        }
        totals.push({
            label: "Grand Total",
            bold: true,
            amount:
                rush_processing_fee +
                shipping_charge +
                subtotal +
                tax +
                custom_charge_total -
                discount
        });
        return totals;
    },
    openInvoicePdf(order) {
        window.open(`/web-api/order/${order.id}/download-invoice`, "_blank");
    },
    openSageInvoicePdf(order) {
        window.open(
            `/web-api/order/${order.id}/download-sage-invoice`,
            "_blank"
        );
    }
};

export default OrderUtils;
